import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { SessionStorageService } from './session-storage.service';
import { OAuthConstants } from 'src/app/oauth/constant/oAuth.constants';

@Injectable({
    providedIn: 'root'
})
export class DomainDataService {
    constructor(private _sessionStorageService: SessionStorageService) { }
    private _domainSource = new Subject<string>();
    public domainSource: Observable<string> = this._domainSource.asObservable();

    public setDomain(value): void {
        this._sessionStorageService.put(OAuthConstants.DOMAIN, value);
        this._domainSource.next(value);
    }
    public getDomain(): string {
        return this._sessionStorageService.value(OAuthConstants.DOMAIN) || '';
    }

    public setDomainIfNotExists(): void {
        const storedDomain = this._sessionStorageService.value(OAuthConstants.DOMAIN);
        if (!storedDomain) {
            console.warn("stored domain is not available")
            const host = window.location.host;
            const encodedDomain = window.btoa(host);
            this.setDomain(encodedDomain);
        }
    }
}
